import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'
import CompanyReview from '../../components/views/admin/CompanyReview'

import injectRole from '../../components/HOC/injectRole'

import { TRoutes } from '../../shared/const'
import { mayOpenAdminPage } from '../../shared/alumni'

function CompanyReviewPage(props) {
	if (mayOpenAdminPage(props.role, 'companyReview')) return <CompanyReview />
	else return <Redirect to={TRoutes.DASHBOARD} />
}

CompanyReviewPage.propTypes = {
	role: PropTypes.string.isRequired
}

export default injectRole(CompanyReviewPage)
